import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbConfigScondKey } from 'app/abstract/full-pages/config-scond-key/config-scond-key.abstract';


@Injectable({ providedIn: 'root' })
export class ConfigScondKeyService extends AbConfigScondKey {

  constructor(http: HttpClient) {
    super(http);
  }

  public getEventos(): Observable<any> {
    return this.get(`evento/all`);
  }
}